module.exports = __webpack_public_path__ + "img/3-2.ff0aa848.png";